import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function search(params) {
  const payload = params; //jsona.serialize(params);

  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/search_lists/companyProfiles`, payload, options)
    .then((res) => {
      return res;
    });
}

function createProfile(params) {
  const payload = params;

  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/create/companyProfile`, payload, options)
    .then((res) => {
      return res;
    });
}

function favoriteCompany(params) {
  const payload = params;

  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/favorites/add`, payload, options)
    .then((res) => {
      return res;
    });
}

function unfavoriteCompany(params) {
  const payload = params;

  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/favorites/delete`, payload, options)
    .then((res) => {
      return res;
    });
}

function favorites(params) {
  const payload = params;

  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/favorites/get`, payload, options)
    .then((res) => {
      return res.data;
    });
}

export default {
  search,
  createProfile,
  favoriteCompany,
  favorites,
  unfavoriteCompany,
};
